import React from "react";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import search_icon from "../../assets/SAP-Dashboard/search_icon.png";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../../api";
import { useEffect } from "react";

const EnrollDiscoverCard = () => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        borderRadius: "16px",
        p: 2,
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
        position: "relative",
        textAlign: "center",
      }}
    >
      {/* Search Icon - Top Right */}
      <Box
        component="img"
        src={search_icon}
        alt="search icon"
        sx={{
          width: 40,
          height: 60,
          position: "absolute",
          right: 16,
          // opacity: "60%",
        }}
      />

      <CardContent>
        {/* Heading */}
        <Typography
          variant="h2"
          sx={{ fontWeight: "600", color: "#572575", mb: 1 }}
        >
          Enroll & Discover
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          sx={{
            color: "#4B4B4B",
            mb: 2,
            px: 2,
          }}
        >
          Enroll now to explore handpicked programs aligned with your future !
        </Typography>

        {/* Button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#572575",
            borderRadius: "30px",
            textTransform: "none",
            fontWeight: "600",
            px: 4,
            py: 1,
            "&:hover": {
              backgroundColor: "#401d59",
            },
          }}
          onClick={() => navigate("/sap/pricing-plan")}
        >
          Enroll Now
        </Button>
      </CardContent>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "60px", // adjust as per design
          height: "60px",
        }}
      >
        <svg
          width="50"
          height="55"
          viewBox="0 0 50 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.7">
            <path
              d="M13.1332 21.8033C2.38473 26.9347 -4.67681 37.6137 3.66972 37.1153C19.3395 36.1795 8.76344 44.9069 17.0046 44.6502C25.2457 44.3935 38.0023 42.6359 46.3492 33.9866C54.6961 25.3374 46.5826 23.2702 43.1994 23.605C32.0605 24.7075 46.8012 5.72998 13.1332 21.8033Z"
              fill="#F3D199"
            />
            <path
              d="M9.49242 48.8998C9.51485 50.1169 10.4104 52.1147 12.4216 52.0777C14.4327 52.0406 16.7978 49.9827 16.7754 48.7656C16.7529 47.5485 15.1044 46.5919 13.0933 46.629C11.0821 46.666 9.46999 47.6828 9.49242 48.8998Z"
              fill="#F3D199"
            />
            <path
              d="M6.47275 53.8055C6.4836 54.3948 7.00197 54.8632 7.63057 54.8516C8.25913 54.84 9.50233 54.2135 9.49143 53.6242C9.48058 53.0349 8.70096 52.4456 8.0724 52.4572C7.44384 52.4688 6.46189 53.2161 6.47275 53.8055Z"
              fill="#F3D199"
            />
            <path
              d="M29.6734 31.4692C29.6569 31.265 29.4483 31.0883 29.0952 30.9466C29.479 30.7349 29.6913 30.5081 29.6734 30.2857C29.6191 29.6125 27.4872 29.2351 24.9118 29.4428C22.3363 29.6504 20.2925 30.3644 20.3468 31.0376C20.3632 31.2418 20.5718 31.4185 20.9249 31.5602C20.5411 31.7718 20.3288 31.9987 20.3468 32.2211C20.3632 32.4253 20.5718 32.602 20.9249 32.7437C20.5411 32.9554 20.3288 33.1822 20.3468 33.4047C20.3632 33.6088 20.5718 33.7856 20.9249 33.9272C20.5411 34.1389 20.3288 34.3657 20.3468 34.5882C20.3708 34.8859 20.8017 35.1256 21.497 35.2826C21.4881 35.5026 21.493 35.7438 21.5147 36.01C21.6154 37.2504 23.0107 38.223 24.8561 38.223C26.7015 38.223 28.2988 36.8969 28.3169 35.6525C28.3213 35.3475 28.3084 35.0791 28.2808 34.8406C29.1638 34.5457 29.7016 34.1855 29.6734 33.8362C29.6569 33.632 29.4483 33.4553 29.0952 33.3136C29.479 33.1019 29.6913 32.8751 29.6734 32.6527C29.6569 32.4485 29.4483 32.2717 29.0952 32.1301C29.479 31.9185 29.6913 31.6917 29.6734 31.4692Z"
              fill="url(#paint0_linear_3173_19041)"
            />
            <path
              d="M23.7202 35.5527C22.9553 35.5527 22.2554 35.4965 21.6772 35.3857C21.6436 35.3793 21.6216 35.3469 21.6281 35.3134C21.6345 35.2799 21.6668 35.2579 21.7004 35.2643C22.6053 35.4375 23.8139 35.4757 25.1035 35.3717C26.1588 35.2866 27.1457 35.1164 27.9575 34.8794C27.9904 34.8699 28.0246 34.8887 28.0342 34.9215C28.0438 34.9543 28.0249 34.9887 27.9921 34.9982C27.1724 35.2374 26.177 35.4093 25.1135 35.495C24.6344 35.5336 24.1662 35.5527 23.7202 35.5527Z"
              fill="url(#paint1_linear_3173_19041)"
            />
            <path
              d="M23.7329 34.3673C22.7392 34.3673 21.851 34.2738 21.2246 34.0954C21.1918 34.086 21.1727 34.0519 21.1821 34.019C21.1914 33.9861 21.2255 33.9671 21.2585 33.9764C22.1511 34.2306 23.5884 34.3094 25.1034 34.1873C26.6019 34.0665 27.9995 33.7624 28.8419 33.3738C28.8729 33.3596 28.9097 33.3731 28.924 33.4041C28.9383 33.4351 28.9248 33.4719 28.8937 33.4862C28.0388 33.8805 26.6256 34.1887 25.1134 34.3106C24.6414 34.3486 24.1766 34.3673 23.7329 34.3673Z"
              fill="url(#paint2_linear_3173_19041)"
            />
            <path
              d="M23.7197 33.1846C22.6467 33.1846 21.7077 33.0748 21.0757 32.8664C21.0432 32.8556 21.0256 32.8207 21.0363 32.7883C21.047 32.7558 21.0819 32.7382 21.1144 32.7489C21.9939 33.0389 23.4849 33.1341 25.1028 33.0037C26.6013 32.8829 27.9989 32.5788 28.8414 32.1902C28.8724 32.176 28.9092 32.1895 28.9235 32.2205C28.9378 32.2515 28.9243 32.2883 28.8932 32.3026C28.0382 32.6969 26.625 33.0051 25.1129 33.127C24.6336 33.1656 24.1651 33.1846 23.7197 33.1846Z"
              fill="url(#paint3_linear_3173_19041)"
            />
            <path
              d="M23.7288 32.0014C22.8776 32.0014 22.1035 31.9326 21.5016 31.7989C21.4683 31.7914 21.4472 31.7584 21.4546 31.725C21.462 31.6917 21.4952 31.6706 21.5284 31.6781C22.4334 31.8792 23.7366 31.9313 25.1036 31.821C26.5888 31.7013 27.9792 31.4005 28.8231 31.0163C28.8541 31.0021 28.8908 31.0159 28.905 31.047C28.9192 31.0781 28.9054 31.1148 28.8743 31.1289C28.0181 31.5187 26.6122 31.8235 25.1136 31.9443C24.6401 31.9825 24.1739 32.0014 23.7288 32.0014Z"
              fill="url(#paint4_linear_3173_19041)"
            />
            <path
              d="M18.618 25.4953C18.3052 24.3874 17.7739 23.352 17.0583 22.4502C15.5251 20.5179 13.0238 16.5881 12.716 11.2246C12.2681 3.42322 19.1871 -0.48259 25.5007 0.0476506C31.8144 0.577891 38.0443 5.27889 37.3623 12.5365C36.9426 17.0022 34.4431 20.3895 32.5821 22.3347C31.4004 23.57 30.5575 25.083 30.1011 26.7304C29.5426 28.7468 28.2136 31.2598 25.0545 31.4129C20.9667 31.6112 19.2689 27.8009 18.618 25.4953Z"
              fill="url(#paint5_linear_3173_19041)"
            />
            <path
              d="M26.0987 29.8577L28.3078 15.4893C28.3534 15.1925 28.4996 14.9931 28.6341 15.0441C28.7687 15.095 28.8408 15.377 28.7951 15.6738C28.7939 15.6817 28.7923 15.6915 28.7909 15.6992L26.2745 29.9342C26.2556 30.0412 26.2012 30.1088 26.1531 30.0851C26.1064 30.0622 26.0828 29.9614 26.0987 29.8577Z"
              fill="url(#paint6_linear_3173_19041)"
            />
            <path
              d="M23.8059 29.972L21.5967 15.6036C21.5511 15.3068 21.405 15.1074 21.2704 15.1583C21.1358 15.2093 21.0638 15.4912 21.1094 15.788C21.1106 15.796 21.1123 15.8057 21.1136 15.8135L23.63 30.0484C23.6489 30.1554 23.7033 30.223 23.7515 30.1994C23.7981 30.1765 23.8218 30.0757 23.8059 29.972Z"
              fill="url(#paint7_linear_3173_19041)"
            />
            <path
              opacity="0.79"
              d="M28.2927 14.2545C28.2366 14.1643 28.1068 14.1306 28.0027 14.1792L26.7726 14.754L26.3456 13.5374C26.323 13.4739 26.2707 13.4176 26.196 13.3869C26.0545 13.3286 25.8853 13.3807 25.818 13.5034L25.8159 13.5073L24.8042 15.3518L23.8655 12.7261L23.8639 12.7218C23.841 12.6577 23.7925 12.6001 23.7219 12.5615C23.5645 12.4756 23.3565 12.5166 23.2574 12.653L21.8431 14.5999C21.7856 14.6797 21.8054 14.7867 21.893 14.8456C21.9864 14.9086 22.1211 14.894 22.1937 14.813L23.4389 13.4239L24.5601 15.9217L24.5609 15.9237C24.5789 15.9636 24.6127 15.9985 24.6597 16.0205C24.7649 16.0697 24.8962 16.0358 24.9531 15.9446L26.035 14.2084L26.4422 15.0865L26.4458 15.0943C26.4488 15.1006 26.4521 15.1068 26.456 15.113C26.512 15.2031 26.6417 15.2368 26.7457 15.1882L28.2058 14.506C28.3099 14.4573 28.3488 14.3447 28.2927 14.2545Z"
              fill="white"
            />
            <path
              opacity="0.79"
              d="M32.6292 20.4164C32.5846 20.4164 32.5396 20.4026 32.5011 20.374C32.4055 20.3032 32.3856 20.1683 32.4565 20.0729C32.834 19.5642 33.1801 19.0384 33.4853 18.51C33.5446 18.4069 33.6766 18.3718 33.7793 18.4313C33.8823 18.4907 33.9175 18.6224 33.8581 18.7253C33.5448 19.2679 33.1895 19.8076 32.8021 20.3295C32.7599 20.3864 32.6949 20.4164 32.6292 20.4164Z"
              fill="white"
            />
            <path
              opacity="0.79"
              d="M34.4476 17.2986C34.419 17.2986 34.3899 17.2929 34.362 17.2808C34.253 17.2334 34.2029 17.1066 34.2503 16.9975C36.5925 11.6037 34.571 7.0562 34.5503 7.01087C34.501 6.90285 34.5485 6.77512 34.6565 6.7257C34.7644 6.67616 34.8923 6.72353 34.9417 6.83164C34.9633 6.87859 37.0667 11.5924 34.6452 17.169C34.61 17.2501 34.5307 17.2986 34.4476 17.2986Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_3173_19041"
              x1="30.1072"
              y1="28.3052"
              x2="47.6517"
              y2="12.0956"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09005D" />
              <stop offset="1" stop-color="#1A0F91" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3173_19041"
              x1="20.0778"
              y1="46.006"
              x2="45.0452"
              y2="-11.103"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4F52FF" />
              <stop offset="1" stop-color="#4042E2" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_3173_19041"
              x1="19.7518"
              y1="45.8626"
              x2="44.719"
              y2="-11.2462"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4F52FF" />
              <stop offset="1" stop-color="#4042E2" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_3173_19041"
              x1="19.2474"
              y1="45.6423"
              x2="44.2146"
              y2="-11.4665"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4F52FF" />
              <stop offset="1" stop-color="#4042E2" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_3173_19041"
              x1="19.004"
              y1="45.5364"
              x2="43.9711"
              y2="-11.5722"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4F52FF" />
              <stop offset="1" stop-color="#4042E2" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_3173_19041"
              x1="25.2099"
              y1="7.80075"
              x2="23.7034"
              y2="38.5776"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF928E" />
              <stop offset="1" stop-color="#FE7062" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_3173_19041"
              x1="53.9362"
              y1="-0.706161"
              x2="17.5635"
              y2="31.1469"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E1473D" />
              <stop offset="1" stop-color="#E9605A" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_3173_19041"
              x1="51.8844"
              y1="-3.04938"
              x2="15.5117"
              y2="28.8036"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E1473D" />
              <stop offset="1" stop-color="#E9605A" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Card>
  );
};

export default EnrollDiscoverCard;
